
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const testimonials = [
  {
    name: "Maria Rodriguez",
    role: "Community Organizer",
    content:
      "Okkio has transformed how our neighborhood approaches safety. By giving residents a direct way to report concerns, we've seen faster response times and better communication with local law enforcement.",
    avatar: "MR",
  },
  {
    name: "James Chen",
    role: "Neighborhood Watch Leader",
    content:
      "The impact dashboard helps us track patterns and focus our neighborhood watch efforts. It's incredibly satisfying to see how our collective reporting has reduced break-ins by over 30% in just six months.",
    avatar: "JC",
  },
  {
    name: "Sarah Johnson",
    role: "City Resident",
    content:
      "I was hesitant to report suspicious activity until I found Okkio. The anonymous reporting feature gave me the confidence to share information without worrying about my privacy.",
    avatar: "SJ",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="bg-navy-50 py-20">
      <div className="container">
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <h2 className="mb-4 text-3xl font-bold text-navy-800 md:text-4xl">
            What Our Users Say
          </h2>
          <p className="text-lg text-gray-600">
            Hear from citizens who are making their communities safer with Okkio.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="rounded-lg bg-white p-6 shadow-sm"
            >
              <div className="mb-6 flex items-center">
                <Avatar className="h-12 w-12 border-2 border-navy-200">
                  <AvatarFallback className="bg-navy-100 text-navy-700">
                    {testimonial.avatar}
                  </AvatarFallback>
                </Avatar>
                <div className="ml-4">
                  <p className="font-bold text-navy-800">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>
              <p className="italic text-gray-600">"{testimonial.content}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
